var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section", staticStyle: { padding: "10px 0 0 20px" } },
    [
      _c("span", { staticStyle: { color: "red", "line-height": "30px" } }, [
        _vm._v(
          "注意:下列组件的具体使用可参考相关代码，如无特殊需要，可直接拷贝使用"
        )
      ]),
      _c(
        "el-form",
        { attrs: { inline: true, "label-position": "right" } },
        [
          _c("cargo-area", {
            attrs: {
              country: "CN",
              province: _vm.form.province,
              city: _vm.form.city,
              district: _vm.form.district
            },
            on: {
              "update:province": function($event) {
                return _vm.$set(_vm.form, "province", $event)
              },
              "update:city": function($event) {
                return _vm.$set(_vm.form, "city", $event)
              },
              "update:district": function($event) {
                return _vm.$set(_vm.form, "district", $event)
              }
            }
          })
        ],
        1
      ),
      _c(
        "el-form",
        { attrs: { "label-position": "left", "label-width": "90px" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "多选下拉框" } },
            [
              _c(
                "cargo-multi-select",
                {
                  staticStyle: { width: "205px" },
                  model: {
                    value: _vm.form.mutliValue,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "mutliValue", $$v)
                    },
                    expression: "form.mutliValue"
                  }
                },
                _vm._l(
                  [
                    { label: "零", value: "0" },
                    { label: "一", value: "1" },
                    { label: "二", value: "2" }
                  ],
                  function(item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: { label: item.label, value: item.value }
                    })
                  }
                ),
                1
              ),
              _c("span", [
                _c("i", { staticClass: "el-icon-document" }, [
                  _vm._v("简述:传入和返回的值用逗号分隔")
                ])
              ])
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "可扩展输入框" } },
            [
              _c("cargo-input", {
                staticStyle: { width: "205px" },
                attrs: { "auto-uppercase": true },
                model: {
                  value: _vm.form.cargoText,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "cargoText", $$v)
                  },
                  expression: "form.cargoText"
                }
              }),
              _c("span", [
                _c("i", { staticClass: "el-icon-document" }, [
                  _vm._v("简述:对应旧版flash组件-SmartTextInput")
                ])
              ])
            ],
            1
          ),
          _c("el-form-item", { attrs: { label: "报表控件" } }, [
            _c(
              "div",
              { staticStyle: { width: "205px", float: "left" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        _vm.templateSelectorDialog.visible = true
                      }
                    }
                  },
                  [_vm._v("批量打印")]
                )
              ],
              1
            ),
            _c("span", [
              _c("i", { staticClass: "el-icon-document" }, [
                _vm._v("简述:对应旧版flash组件-TemplateSelectorWin")
              ])
            ])
          ]),
          _c("el-form-item", { attrs: { label: "通用文件上传" } }, [
            _c(
              "div",
              { staticStyle: { width: "205px", float: "left" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        _vm.fileUpload.visible = true
                      }
                    }
                  },
                  [_vm._v("通用文件上传")]
                )
              ],
              1
            ),
            _c("span", [
              _c("i", { staticClass: "el-icon-document" }, [
                _vm._v("简述:对应旧版flash组件-UploadCommonFile")
              ])
            ])
          ]),
          _c("el-form-item", { attrs: { label: "云文件上传" } }, [
            _c(
              "div",
              { staticStyle: { width: "205px", float: "left" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        _vm.cloudFile.visible = true
                      }
                    }
                  },
                  [_vm._v("云文件上传")]
                )
              ],
              1
            ),
            _c("span", [
              _c("i", { staticClass: "el-icon-document" }, [
                _vm._v("简述:对应旧版flash组件-CloudFileUpload")
              ])
            ])
          ])
        ],
        1
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c("cargo-file-upload-dialog", {
        attrs: {
          visible: _vm.fileUpload.visible,
          title: _vm.fileUpload.title,
          "document-category": _vm.fileUpload.documentCategory,
          "business-id": _vm.fileUpload.businessId,
          "show-file-category": _vm.fileUpload.showFileCategory,
          lob: _vm.fileUpload.lob,
          parameters: _vm.fileUpload.parameters
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.fileUpload, "visible", $event)
          },
          uploadDone: _vm.onUploadDone
        }
      }),
      _c("cargo-cloud-file-upload", {
        attrs: {
          visible: _vm.cloudFile.visible,
          job: _vm.cloudFile.job,
          lob: _vm.cloudFile.lob,
          "show-all": _vm.cloudFile.showAll
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cloudFile, "visible", $event)
          },
          uploadDone: _vm.onUploadDone
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }